import antisune from './antisune';
import bowtie from './bowtie';
import cross from './cross';
import hammerhead from './hammerhead';
import headlights from './headlights';
import sune from './sune';
import wheel from './wheel';

export default {
  cases: [
    sune,
    antisune,
    cross,
    wheel,
    headlights,
    hammerhead,
    bowtie,
  ],
  name: 'OLL Corner Cases',
};
